enum EViewType {
  ListView = 0,
  ContentView = 1,
  ThumbnailView = 2,
  DetailView = 3,
}

export const EViewTypeDisplayNames: Record<string, EViewType> = {
  'List View (Default)': EViewType.ListView,
  'Content View': EViewType.ContentView,
  'Thumbnail View': EViewType.ThumbnailView,
  'Detail View': EViewType.DetailView,
};

export default EViewType;
